import React, { useMemo } from 'react';

import { idsNamedIn } from '../../utils/filterIds';

/**
 * The line beneath a filter's TEXT naming each id it holds (deterministic
 * filters ruling E10; utils/filterIds.js) — a card, a set, a record, a tag,
 * and since element ids an element (`#k7f3q2xa` reads as its label, "An
 * element that is no longer here" when nothing holds it). The builder's
 * Advanced tab shows it; so does every editor that keeps a filter as typed
 * text (a page layout's query, a card's worklist, a multi add seed, a driven
 * total's filter), whose saved text the server writes with ids (element ids
 * step 3) — so no bare id is ever left unexplained.
 *
 * `entries` (precomputed `idsNamedIn`) or `text` + `fields`. Renders nothing
 * when the text names no id.
 */
export default function FilterIdsLine({ text = '', fields = [], entries = null, titleFor = null, removedIds = null, unknownElement = null, className = '' }) {
	const named = useMemo(
		() => (Array.isArray(entries) ? entries : idsNamedIn(text, fields, { titleFor, removedIds, unknownElement })),
		[entries, text, fields, titleFor, removedIds, unknownElement]
	);
	if (!named.length) return null;
	return (
		<ul className={['list-filter__ids', className].filter(Boolean).join(' ')} aria-label="What the ids in this filter name">
			{named.map(entry => (
				<li key={`${entry.noun}:${entry.id}`} className="list-filter__id">
					<code className="list-filter__id-value">{entry.id}</code>
					<span className="list-filter__id-name">
						{entry.label || `a ${entry.noun} not found here`}
						{entry.label && !entry.removed ? <span className="list-filter__id-noun">{` · ${entry.noun}`}</span> : null}
					</span>
				</li>
			))}
		</ul>
	);
}
